<div class="card shadow-sm">
  <div class="card-body">
    <div class="row">
      <div class="col">
        <h4 class="mb-3">{{ header }}</h4>
      </div>
    </div>

    <div class="row">
      <div class="col" [tds-data-loader]="{ key: 'user-assets', size: 'lg', class: 'm-2' }">
        @if (user_assets && user_assets.length > 0) {
          @if (no_asset_alert) {
            <div class="row">
              <div class="col">
                <ngb-alert role="alert" class="show" [type]="'primary'" [dismissible]="false">
                  <span>
                    {{ no_asset_alert }}
                  </span>
                </ngb-alert>
              </div>
            </div>
          }
          <div class="d-flex flex-column gap-3">
            @for (asset of user_assets; track asset) {
              <div
                as-button
                class="card position-relative overflow-hidden elevate-white asset-card"
                [attr.aria-label]="assetAriaLabel(asset)"
                (click)="selectAsset(asset)"
              >
                @if (asset.line && asset.line?.is_primary_contact) {
                  <div
                    class="position-absolute top-0 start-0 asset-card__primary"
                    aria-label="Primary line"
                  >
                    <span class="material-icons">verified</span>
                  </div>
                }
                @if (isSelectedAsset(asset) && existing_asset?.asset_selection_case === 1) {
                  <div class="position-absolute top-0 start-100 text-end currently-in-cart">
                    <span ngbTooltip="{{ 'selected_item' | translate }}" class="material-icons">
                      check_circle
                    </span>
                  </div>
                }
                <div class="card-body card-items card-items-md asset-card__details">
                  <ts-asset-selection-item
                    class="d-contents"
                    [asset]="asset"
                    [asset_fields]="asset_fields"
                  />
                </div>
                @if (hasMultiSim(asset)) {
                  <div stop-click-propagation class="card-footer">
                    <button
                      type="button"
                      class="d-flex justify-content-center btn text-capitalize fw-normal w-100"
                      data-bs-toggle="offcanvas"
                      data-bs-target="#multiSimOffCanvas"
                      aria-controls="multiSimOffCanvas"
                      (click)="openAssetOffCanvas(multiSimOffCanvas, asset)"
                    >
                      @if (asset.multi_sim_type === multi_sim_types[0]) {
                        <span>
                          <span class="material-icons lh-base">hub</span>&nbsp;
                          <span>
                            {{ 'additional_lines' | translate }}
                            ({{ asset.additional_lines?.length }})
                          </span>
                        </span>
                      }
                      @if (
                        [multi_sim_types[1], multi_sim_types[6]].includes(asset.multi_sim_type)
                      ) {
                        <span>
                          <span class="material-icons lh-base">hub</span>&nbsp;
                          <span>
                            {{ 'additional_devices' | translate }}
                            ({{ asset.additional_devices?.length }})
                          </span>
                        </span>
                      }
                    </button>
                  </div>
                }
              </div>
            }
          </div>
        } @else {
          @if (!!user_assets) {
            <ngb-alert role="alert" class="show" [type]="'info'" [dismissible]="false">
              <span>{{ no_asset_text }}</span>
            </ngb-alert>
          }
        }
      </div>
    </div>

    <ng-container [ngTemplateOutlet]="cardTemplate"></ng-container>
  </div>
</div>

<ng-template #multiSimOffCanvas let-offcanvas>
  <ts-multisim-offcanvas
    class="overflow-auto"
    [offcanvas_asset]="offcanvas_asset"
    [offcanvas]="offcanvas"
  ></ts-multisim-offcanvas>
</ng-template>
